import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import { features } from "../data";
import { Card, IconChip, Section, SectionHeader } from "../shared";

const iconMap = {
  groups: <GroupsOutlinedIcon />,
  sparkle: <AutoAwesomeOutlinedIcon />,
  trending: <TrendingUpOutlinedIcon />,
  insights: <InsightsOutlinedIcon />,
};

/**
 * Three-card feature grid highlighting the core DojoMojo workflow.
 *
 * @returns {import("react").ReactElement}
 */
export function Features() {
  return (
    <Section id="features" className="bg-white">
      <SectionHeader
        tag="How it works"
        title={
          <>
            The Complete Toolkit, <span className="text-cerulean">Built For Growth.</span>
          </>
        }
        subtitle="Everything you need to launch, scale, and measure a viral giveaway — in one beautifully designed platform."
      />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
        {features.map((feature) => (
          <Card key={feature.title} padding="lg" hover>
            <IconChip tint={feature.tint} size="lg">
              {iconMap[feature.iconKey]}
            </IconChip>
            <h3 className="text-ink mt-6 mb-3 text-xl font-semibold tracking-tight">
              {feature.title}
            </h3>
            <p className="text-muted text-[15.5px] leading-relaxed">{feature.body}</p>
          </Card>
        ))}
      </div>
    </Section>
  );
}
